import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';
import './legal.css';

/**
 * Страница Условий использования
 */
export default function TermsPage() {
    return (
        <>
            <SEO 
                title="Пользовательское соглашение"
                description="Пользовательское соглашение платформы Spiria. Правила и условия использования нашего сервиса."
                canonical="https://spiria.ru/terms"
            />
            
            <div className="legal-page">
                {/* Header */}
                <div className="legal-header">
                    <div className="legal-header-content">
                        <Link to="/" className="legal-logo">
                            <svg 
                                version="1.0" 
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 294 295"
                                width="40"
                                height="40"
                                fill="currentColor"
                            >
                                <g transform="translate(0.000000,295.000000) scale(0.100000,-0.100000)" fill="#2f6fed" stroke="none">
                                    <path d="M1281 2855 c-215 -47 -403 -162 -535 -327 -294 -367 -266 -893 63
-1227 166 -168 402 -271 620 -271 l65 0 -39 -41 c-213 -220 -572 -258 -836
-87 -191 122 -309 340 -309 568 0 41 5 95 11 120 8 35 6 63 -7 130 -11 54 -18
135 -18 222 -1 131 -2 136 -19 120 -31 -27 -105 -145 -137 -217 -60 -133 -75
-213 -74 -385 1 -138 4 -165 27 -243 48 -155 117 -276 221 -385 333 -349 866
-385 1246 -85 196 155 314 377 344 648 l11 100 58 -70 c202 -244 221 -557 50
-817 -62 -94 -150 -171 -258 -224 -138 -68 -282 -90 -418 -63 -46 10 -70 8
-144 -7 -58 -12 -134 -18 -220 -18 -73 -1 -133 -2 -133 -3 0 -11 146 -106 215
-139 145 -71 223 -87 405 -87 140 0 164 2 243 26 167 51 303 134 418 253 110
116 177 232 225 389 25 82 27 104 27 245 0 182 -16 260 -87 405 -95 198 -248
347 -450 441 -92 42 -176 63 -306 78 l-105 12 70 57 c145 120 301 173 480 164
178 -10 304 -66 436 -197 149 -147 208 -302 195 -514 -4 -61 -8 -122 -8 -136
-1 -14 7 -71 16 -128 12 -67 17 -138 14 -206 -4 -122 -4 -122 77 -2 65 96 117
221 141 336 24 122 16 314 -20 433 -100 335 -365 578 -706 649 -131 28 -307
21 -433 -16 -384 -113 -651 -448 -669 -838 -2 -38 -5 -68 -8 -68 -13 0 -90 89
-122 140 -234 373 -62 852 359 1001 72 26 269 37 337 20 36 -9 58 -8 113 6 47
11 116 16 220 17 84 1 153 3 153 6 0 9 -110 85 -177 122 -72 40 -182 79 -271
97 -73 15 -274 12 -351 -4z m290 -1230 c64 -42 99 -132 79 -204 -50 -187 -317
-189 -365 -3 -24 92 13 174 98 217 64 33 130 29 188 -10z"/>
                                </g>
                            </svg>
                            <span>Spiria</span>
                        </Link>
                        <Link to="/" className="legal-back">← На главную</Link>
                    </div>
                </div>

                {/* Content */}
                <div className="legal-container">
                    <div className="legal-content-wrapper">
                        <h1>Пользовательское соглашение</h1>
                        <p className="legal-last-updated">Последнее обновление: {new Date().toLocaleDateString('ru-RU')}</p>
                        
                        <section className="legal-section">
                            <h2>1. Общие положения</h2>
                            <p>
                                Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует отношения 
                                между ООО «Спириа» (далее — «Администрация») и пользователем платформы Spiria 
                                (далее — «Пользователь»).
                            </p>
                            <p>
                                Используя платформу, Пользователь подтверждает свое согласие с условиями настоящего 
                                Соглашения и обязуется их соблюдать.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>2. Предмет соглашения</h2>
                            <p>
                                Администрация предоставляет Пользователю доступ к платформе Spiria для 
                                управления здоровьем, включая:
                            </p>
                            <ul>
                                <li>Создание и прохождение медицинских опросов</li>
                                <li>Управление расписанием приёма лекарств</li>
                                <li>Связь с медицинскими работниками</li>
                                <li>Хранение медицинских данных</li>
                                <li>Получение напоминаний о мероприятиях по здоровью</li>
                            </ul>
                            <p>
                                Доступ предоставляется на условиях безвозмездной лицензии, если иное 
                                не предусмотлено отдельным договором.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>3. Регистрация и обязанности сторон</h2>
                            <p><strong>Пользователь обязуется:</strong></p>
                            <ul>
                                <li>Предоставить достоверные и актуальные данные при регистрации</li>
                                <li>Поддерживать актуальность информации в профиле</li>
                                <li>Не передавать доступ к аккаунту третьим лицам</li>
                                <li>Немедленно уведомить Администрацию о несанкционированном доступе</li>
                                <li>Не использовать платформу для нарушения прав третьих лиц</li>
                            </ul>
                            <p><strong>Администрация обязуется:</strong></p>
                            <ul>
                                <li>Обеспечить работоспособность платформы</li>
                                <li>Защищать персональные данные Пользователя</li>
                                <li>Предоставлять техническую поддержку</li>
                                <li>Уведомлять о значительных изменениях в работе платформы</li>
                            </ul>
                        </section>

                        <section className="legal-section">
                            <h2>4. Ответственность сторон</h2>
                            <p><strong>4.1. Ответственность Пользователя:</strong></p>
                            <p>
                                Пользователь несёт ответственность за:
                            </p>
                            <ul>
                                <li>Достоверность предоставляемых данных</li>
                                <li>Сохранность учётных данных (логина и пароля)</li>
                                <li>Действия, совершённые под его учётной записью</li>
                                <li>Соблюдение законодательства РФ при использовании платформы</li>
                            </ul>
                            <p><strong>4.2. Ответственность Администрации:</strong></p>
                            <p>
                                Администрация не несёт ответственности за:
                            </p>
                            <ul>
                                <li>Медицинские решения, принятые Пользователем на основе информации платформы</li>
                                <li>Технические сбои, вызванные обстоятельствами непреодолимой силы</li>
                                <li>Убытки от использования или невозможности использования сервиса</li>
                                <li>Действия третьих лиц</li>
                            </ul>
                            <p>
                                <strong>Важно:</strong> Spiria является вспомогательным инструментом и не заменяет 
                                очную консультацию с врачом. В экстренных случаях звоните 103.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>5. Интеллектуальные права</h2>
                            <p>
                                Все материалы, размещённые на платформе (логотипы, тексты, дизайн, программный код), 
                                являются интеллектуальной собственностью Администрации или её лицензиаров.
                            </p>
                            <p>
                                Пользователю предоставляется ограниченное, неисключительное, непередаваемое право 
                                использовать платформу в личных целях в соответствии с настоящим Соглашением.
                            </p>
                            <p>Запрещается:</p>
                            <ul>
                                <li>Копирование, модификация или распространение материалов платформы</li>
                                <li>Попытки декомпиляции или обратного инжиниринга</li>
                                <li>Использование автоматизированных средств сбора данных</li>
                                <li>Создание фреймов или зеркал вокруг платформы</li>
                            </ul>
                        </section>

                        <section className="legal-section">
                            <h2>6. Конфиденциальность</h2>
                            <p>
                                Администрация обязуется соблюдать конфиденциальность персональных данных 
                                Пользователя в соответствии с <Link to="/privacy">Политикой конфиденциальности</Link> 
                                и законодательством РФ.
                            </p>
                            <p>
                                Пользователь соглашается с обработкой его персональных данных для целей 
                                предоставления услуг платформы.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>7. Изменение и расторжение соглашения</h2>
                            <p>
                                <strong>7.1.</strong> Администрация оставляет за собой право изменять настоящее 
                                Соглашение в одностороннем порядке. Изменения вступают в силу с момента их 
                                размещения на платформе.
                            </p>
                            <p>
                                <strong>7.2.</strong> Продолжение использования платформы после изменения 
                                Соглашения означает принятие Пользователем новых условий.
                            </p>
                            <p>
                                <strong>7.3.</strong> Администрация вправе приостановить или прекратить доступ 
                                Пользователя к платформе в случае нарушения настоящего Соглашения.
                            </p>
                            <p>
                                <strong>7.4.</strong> Пользователь вправе прекратить использование платформы 
                                в любое время путём удаления своей учётной записи.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>8. Разрешение споров</h2>
                            <p>
                                <strong>8.1.</strong> Все споры и разногласия, возникающие из настоящего 
                                Соглашения, подлежат разрешению путём переговоров.
                            </p>
                            <p>
                                <strong>8.2.</strong> При невозможности достижения соглашения споры подлежат 
                                рассмотрению в судебном порядке по месту нахождения Администрации 
                                (г. Уфа, Республика Башкортостан).
                            </p>
                            <p>
                                <strong>8.3.</strong> К настоящему Соглашению применяется законодательство 
                                Российской Федерации.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>9. Заключительные положения</h2>
                            <p>
                                <strong>9.1.</strong> Настоящее Соглашение составляет полное соглашение 
                                между Пользователем и Администрацией относительно использования платформы.
                            </p>
                            <p>
                                <strong>9.2.</strong> Признание отдельных положений Соглашения недействительными 
                                не влечёт недействительности остальных положений.
                            </p>
                            <p>
                                <strong>9.3.</strong> Все уведомления по Соглашению направляются на email, 
                                указанный Пользователем при регистрации.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>10. Контактная информация</h2>
                            <p>
                                <strong>Администрация платформы:</strong>
                            </p>
                            <p>
                                ООО «Спириа»
                                <br />Email: <a href="mailto:info@spiria.ru">info@spiria.ru</a>
                                <br />Адрес: г. Уфа, Республика Башкортостан
                            </p>
                            <p>
                                По всем вопросам, связанным с настоящим Соглашением, обращайтесь по указанным 
                                контактам.
                            </p>
                        </section>
                    </div>
                </div>

                {/* Footer */}
                <div className="legal-footer">
                    <p>© {new Date().getFullYear()} Spiria. Все права защищены.</p>
                    <div className="legal-footer-links">
                        <Link to="/privacy">Политика конфиденциальности</Link>
                        <Link to="/terms">Условия использования</Link>
                    </div>
                </div>
            </div>
        </>
    );
}
